import { patchRequest, postRequest, getRequest } from 'apis/ApiInstence';
import { put } from 'redux-saga/effects';
import { successMachine, failedMachine } from 'slice/machineSlice';


export function* updateMachineAPI({ payload }) {
  try {
    let header = {
      headers: { "Content-Type": "multipart/form-data" }
    }
    yield patchRequest(`machine/${payload.id}`, payload.data, header);
    const response = yield getRequest('machine');
    if (response?.status == 200) {
      yield put(successMachine(response?.data));
    } else {
      yield put(failedMachine(response));
    }
  } catch (error) {
    console.log(error)
  }
}

export function* addMachineFun({ payload }) {
  try {
    const response = yield postRequest(`machine`, payload);
    if (response?.status == 201) {
      const list = yield getRequest('machine');
      yield put(successMachine(list?.data));
    } else {
      yield put(failedMachine(response));
    }
  } catch (error) {
    console.log(error)
  }
}

export function* getMachineFun() {
  try {
    const response = yield getRequest('machine');
    if (response?.status == 200) {
      yield put(successMachine(response?.data));
    } else {
      yield put(failedMachine(response));
    }
  } catch (error) {
    console.log(error)
  }
}
